import { GeometryContainer, Vertex } from '@spi/Common/Geometry';
import { DataWriter } from './DataWriter';
import { SerializationUtil } from './SerializationUtil';

export class GeometryWriter extends DataWriter<GeometryContainer> {

    public write(geo: GeometryContainer): Uint8Array {
        let vertexMap = new Map<Vertex, number>();

        // Collect all vertices
        for (let face of geo.faces) {
            for (let vertex of face.vertices) {
                if (!vertexMap.has(vertex)) {
                    vertexMap.set(vertex, vertexMap.size);
                }
            }
        }

        let buffer = new ArrayBuffer(1024 + vertexMap.size * 100 + geo.faces.length * 100); // kind of arbitrary size, hope that is enough (and not too much)

        let util = new SerializationUtil().writeTo(new DataView(buffer));

        util.writeString(geo.reference);
        util.writeString(geo.textureReference);
        util.writeUint8(geo.type);

        util.writeUint32(vertexMap.size);
        for (let vertex of vertexMap.keys()) {
            util
                .writeVec3(vertex.position)
                .writeVec3(vertex.normal)
                .writeVec4(vertex.color ? vertex.color : [1, 1, 1, 1]);
        }

        util.writeUint32(geo.faces.length);
        for (let face of geo.faces) {
            for (let vertex of face.vertices) {
                util
                    .writeUint32(vertexMap.get(vertex))
                    .writeVec2(face.getTextureOffset(vertex));
            }
            util.writeVec3(face.normal);
            util.writeUint8(face.traversability);
        }

        return util.finalize(true);
    }
}
